import React from 'react';
import IconCollection from "../../IconCollection/IconCollection";
import { useDispatch } from 'react-redux';

const SearchInput = ({ searchText, setSearchText, isMouseOverInput, setIsMouseOverInput }) => {
  const dispatch = useDispatch();
  return (
    <div className={`max-w-10 w-full h-10 md:h-12 border-[#ABABAB] border-[1px] rounded py-0 md:py-3 px-0 md:px-4 flex md:justify-start justify-center items-center gap-[10px] ${isMouseOverInput ? "max-w-full border-none" : "md:max-w-[455px] border-[1px]"}`}>
      <div>
        {isMouseOverInput ? (
          <div onClick={() => dispatch(setIsMouseOverInput(false))} className="flex items-center gap-2 cursor-pointer w-[120px]">
            <IconCollection customClass='md:min-w-[25px] min-w-[15px]  md:h-[24px] h-[16px]' name="arrow-left" />
            <p className="text-[#4A4A4A] font-montserrat font-medium text-xl">Search</p>
          </div>
        ) : (
            <div onClick={() => dispatch(setIsMouseOverInput(true))}>
               <IconCollection  name="search" />
         </div>
        )}
      </div>
      <input
        onClick={() => dispatch(setIsMouseOverInput(true))}
        className={`border-none md:inline-flex mt-[-9px] placeholder:leading-[0] w-full  text-3xl outline-none placeholder:text-[#636363] placeholder:text-sm placeholder:font-medium font-normal ${!isMouseOverInput ? "hidden" : "block"}`}
        placeholder={isMouseOverInput ? "" : "Search all jobs for me"}
        type="text"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
    </div>
  );
};

export default SearchInput;